import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    quoteForm: {
      fromCity: '',
      toCity: '',
      carType: '',
      phone: ''
    }
  },
  mutations: {
    SET_QUOTE_FORM(state, form) {
      state.quoteForm = { ...state.quoteForm, ...form }
    }
  },
  actions: {
    updateQuoteForm({ commit }, form) {
      commit('SET_QUOTE_FORM', form)
    }
  },
  modules: {
  }
})

